import { mergeStyleSets, getTheme } from "@fluentui/react";

const theme = getTheme();

const styles = mergeStyleSets({
  experimentsTablePageContainer: {
    height: "100%",
    minHeight: 0,
  },
  commandBarContainerStyles: {
    childrenGap: 10,
    paddingBottom: 10,
  },
  commandBarContainerHideTopBar: {
    marginTop: 20,
  },
  extensionComboBoxContainer: {
    display: "flex",
    alignItems: "center",
  },
  commandBarStyles: {
    padding: "0",
  },
  commandBarItemStyles: {
    padding: "0 0 5px 0",
  },
  extensionDropdownStyles: {
    maxWidth: 250,
  },
  selectExtension: {
    background: theme.palette.neutralLight,
    padding: 10,
    borderRadius: 5,
    margin: 5,
  },
  experimentsEmptyState: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    height: "40vh",
    color: theme.palette.neutralSecondary,
    fontSize: "20px",
    border: "none",
    boxShadow: "none",
    background: theme.palette.white,
    borderRadius: "0",
    marginTop: "32px",
  },
  experimentsEmptyStateIcon: {
    fontSize: 48,
    marginBottom: 16,
  },
  experimentsEmptyStateText: {
    fontWeight: 600,
    fontSize: 24,
    marginBottom: 8,
  },
  experimentsEmptyStateSubText: {
    fontSize: 16,
  },
  experimentsTable: {
    background: theme.palette.white,
    width: "100%",
    minWidth: "0",
    overflowX: "hidden",
  },
  experimentTableOpenPrLink: {
    display: "inline-flex",
    alignItems: "center",
    color: theme.palette.themePrimary,
    fontWeight: 500,
  },
  experimentTableTitle: {
    display: "inline-block",
    alignItems: "center",
    color: theme.palette.themePrimary,
    fontWeight: 500,
    marginBottom: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "100%",
  },
  experimentTableTitleContainer: {
    display: "flex",
    alignItems: "baseline",
    gap: "8px",
    marginBottom: 14,
    flexWrap: "wrap",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  experimentTableNewBadge: {
    backgroundColor: theme.palette.neutralLighterAlt,
    color: theme.palette.green,
    border: `1px solid ${theme.palette.green}`,
    borderRadius: "4px",
    padding: "2px 6px",
    fontSize: "12px",
    fontWeight: "500",
    whiteSpace: "nowrap",
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
  },
  experimentTableNewBadgeLink: {
    color: theme.palette.green,
    textDecoration: "underline",
  },
  experimentTablePrBadge: {
    backgroundColor: theme.palette.neutralLighterAlt,
    color: theme.palette.orangeLighter,
    border: `1px solid ${theme.palette.orangeLighter}`,
    borderRadius: "4px",
    padding: "2px 6px",
    fontSize: "12px",
    fontWeight: "500",
    whiteSpace: "nowrap",
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
  },
  experimentTablePrBadgeLink: {
    color: theme.palette.orangeLighter,
    textDecoration: "underline",
  },
  experimentTablePrDeleteBadge: {
    backgroundColor: theme.palette.neutralLighterAlt,
    color: theme.palette.red,
    border: `1px solid ${theme.palette.red}`,
    borderRadius: "4px",
    padding: "2px 6px",
    fontSize: "12px",
    fontWeight: "500",
    whiteSpace: "nowrap",
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
  },
  experimentTablePrDeleteBadgeLink: {
    color: theme.palette.red,
    textDecoration: "underline",
  },
  experimentTableIcon: {
    width: "14px",
    height: "14px",
  },
  experimentTableDurationText: {
    textDecoration: "underline dotted",
  },
  experimentTableContainer: {
    height: "100%",
    minHeight: 0,
  },
  experimentTableDescription: {
    fontSize: 12,
    color: theme.palette.neutralSecondary,
    fontWeight: 400,
    whiteSpace: "normal",
    wordWrap: "break-word",
    lineHeight: "1.4",
  },
  experimentTableOpenPrIcon: {
    fontSize: 18,
    marginRight: 6,
    color: theme.palette.themePrimary,
  },
});

export { styles };
